/* eslint-disable */
<template>
    <v-layout row wrap >
        <v-flex lg12 sm12>
            <v-widget title="Les différents âges">
                <div slot="widget-content" id="q1_c" style="height:400px; " ref="q1_c">
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Etat civil" content-bg="white">
                <div slot="widget-content" id="main" style="height:400px; " ref="main">
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Niveau scolaire" content-bg="white">
                <div slot="widget-content" id="q6" style="height:400px;" ref="q6"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Etat civil par rapport au niveau scolaire">
                <div slot="widget-content" id="q1_2" style="height:400px; " ref="q1_2">
                </div>
            </v-widget>
        </v-flex>
        <!-- liste child-->
        <v-flex lg3 sm12 xs12>
            <v-widget title="Nombre d’enfants en parrainage" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr0)
                                    color="success"

                            >

                                {{q7.nbr0}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr1)
                                    color=cyan darken-2

                            >

                                {{q7.nbr1}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr2)
                                    color=deep-orange

                            >
                                {{q7.nbr2}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">plus de 2 ; moins de 5 Enfant </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q7.nbr_moins5)
                                    color=purple lighten-2
                            >

                                {{q7.nbr_moins5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Plus de 5 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value= caption2(q7.nbr_plus5)

                                    color=black


                            >

                                {{q7.nbr_plus5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Nombre d’enfants en cours d’études" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr0)
                                    color="success"
                            >
                                {{q8.nbr0}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr1)
                                    color=cyan darken-2
                            >
                                {{q8.nbr1}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr2)
                                    color=deep-orange
                            >
                                {{q8.nbr2}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">plus de 2 ; moins de 5 Enfant </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q8.nbr_moins5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Plus de 5 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q8.nbr_plus5)
                                    color=black

                            >
                                {{q8.nbr_plus5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Nombre d’enfants qui travaillent" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr0)
                                    color="success"
                            >
                                {{   q9.nbr0    }}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr1)
                                    color=cyan darken-2
                            >
                                {{q9.nbr1}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr2)
                                    color=deep-orange
                            >
                                {{q9.nbr2}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">plus de 2 ; moins de 5 Enfant </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{ q9.nbr_moins5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Plus de 5 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q9.nbr_plus5)
                                    color=black

                            >
                                {{ q9.nbr_plus5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Nombre d’enfants en état de chômage" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr0)
                                    color="success"
                            >
                                {{q10.nbr0}}%
                            </v-progress-circular>
                        </div>

                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr1)
                                    color=cyan darken-2
                            >
                                {{q10.nbr1}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr2)
                                    color=deep-orange
                            >
                                {{q10.nbr2}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">plus de 2 ; moins de 5 Enfant </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q10.nbr_moins5}}%


                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Plus de 5 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q10.nbr_plus5)
                                    color=black

                            >
                                {{q10.nbr_plus5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Nombre d’enfants mariés" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr0)
                                    color="success"
                            >
                                {{q11.nbr0}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr1)
                                    color=cyan darken-2
                            >
                                {{q11.nbr1}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr2)
                                    color=deep-orange
                            >
                                {{q11.nbr2}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">plus de 2 ; moins de 5 Enfant </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q11.nbr_moins5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Plus de 5 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q11.nbr_plus5)
                                    color=black

                            >
                                {{q11.nbr_plus5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Nombre d’enfants handicapés" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">0 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr0)
                                    color="success"
                            >
                                {{q12.nbr0}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">1 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr1)
                                    color=cyan darken-2
                            >
                                {{q12.nbr1}}%


                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">2 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr2)
                                    color=deep-orange
                            >
                                {{q12.nbr2}}%


                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">plus de 2 ; moins de 5 Enfant </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr_moins5)
                                    color=purple lighten-2
                            >
                                {{q12.nbr_moins5}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Plus de 5 Enfant</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q12.nbr_plus5)
                                    color=black

                            >
                                {{q12.nbr_plus5}}%

                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>

        <v-widget title="Nombre moyen d’enfants qui sont en cours d’étude" content-bg="white">
            <div slot="widget-content">

                <div class="layout row ma-0 align-center justify-space-between">
                    <div class="text-box">
                        <div class="subheading pb-2">Enfant par femme</div>
                    </div>
                    <div class="chart">
                        <v-progress-circular
                                :size="60"
                                :width="5"
                                :rotate="360"
                                :value=caption2(qf)*10
                                color=pink darken-3
                        >
                            {{qf}}enfant
                        </v-progress-circular>
                    </div>
                </div></div></v-widget></v-flex>
        <!-- end liste child-->
        <v-flex lg6 sm12 xs12>
            <v-widget title="Subventions">
                <div slot="widget-content">
                    <linear-statistic
                            title="Femmes qui ne bénéficient pas des subventions circonstancielles ou saisonnières"
                            sub-title=""
                            color=red darken-2

                            :value=caption2(q16)
                    >
                    </linear-statistic>

                    <linear-statistic
                            title="Femmes qui ne bénéficient pas des subventions scolaires ou universitaires pour leurs enfants qui sont en cours d’étude "
                            sub-title=""
                            color=red darken-2
                            :value=caption2(q17)
                    >
                    </linear-statistic>
                    <linear-statistic
                            title="Enfants pratiquent le même secteur de palourdes"
                            sub-title=""
                            color="success"
                            :value=caption2(q13)
                    >
                    </linear-statistic>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>

            <circle-statistic
                    sub-title="Seconde source de revenus "
                    color=purple lighten-2
                    :value=caption2(tt)
            >
                {{tt}} %
            </circle-statistic>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Emplacement de leurs enfants lors du travail ">
                <div slot="widget-content" id="q14" style="height:400px; " ref="q14">
                </div>
            </v-widget>
        </v-flex>


        <v-flex lg6 sm12 xs12>
            <v-widget title="les différentes sources de revenus des femmes ">
                <div slot="widget-content" id="q15" style="height:400px; " ref="q15">
                </div>
            </v-widget>
        </v-flex>


        <v-flex lg6 sm12 xs12>
            <v-widget title="Nature d’habitation">
                <div slot="widget-content" id="q18" style="height:400px; " ref="q18">
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="propriétaire d’habitation">
                <div slot="widget-content" id="q19" style="height:400px; " ref="q19"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Etat de logement">
                <div slot="widget-content" id="q20" style="height:400px; " ref="q20"></div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Les équipements " content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Télévision</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.tele)
                                    color=pink darken-3
                            >
                                {{q21.tele}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Réfrigérateur</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.fre)
                                    color=pink darken-3
                            >
                                {{q21.fre}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Ordinateur</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.pc)
                                    color=pink darken-3
                            >
                                {{q21.pc}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">four électrique</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.four)
                                    color=pink darken-3
                            >
                                {{q21.four}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Machine à laver</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q21.machine)
                                    color=pink darken-3
                            >
                                {{q21.machine}}%
                            </v-progress-circular>
                        </div>
                    </div>

                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <circle-statistic
                    sub-title="pourcentage de terres cultivables "
               title=""
                    caption=""
                    color="purple"
                    :value=caption2(q22)           >
            </circle-statistic>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget content-bg="white"title="formation ou spécialisation">
                <div slot="widget-content">
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Femmes ayant reçu des formations </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q23)
                                    color=purple lighten-2
                            >
                                {{q23}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Femmes veulent avoir des formations</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q24)
                                    color=pink lighten-2
                            >
                                {{q24}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Femmes ayant une idée de projet </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=caption2(q25)
                                    color=red accent-2
                            >
                                {{q25}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>

    </v-layout>

</template>

<script>
    import EChart from '@/components/chart/echart';
    import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
    import PostListCard from '@/components/widgets/card/PostListCard';
    import ProfileCard from '@/components/widgets/card/ProfileCard';
    import PostSingleCard from '@/components/widgets/card/PostSingleCard';
    import WeatherCard from '@/components/widgets/card/WeatherCard';
    import PlainTable from '@/components/widgets/list/PlainTable';
    import PlainTableOrder from '@/components/widgets/list/PlainTableOrder';
    import VWidget from '@/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import VCircle from '@/components/circle/VCircle';
    import BoxChart from '@/components/widgets/chart/BoxChart';
    import ChatWindow from '@/components/chat/ChatWindow';
    import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
    import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
    var echarts = require('../../node_modules/echarts');

    /* eslint-disable */
    export default {
        name: "q1-compenent",
        components: {
            VWidget,
            MiniStatistic,
            ChatWindow,
            VCircle,
            WeatherCard,
            PostSingleCard,
            PostListCard,
            ProfileCard,
            EChart,
            BoxChart,
            CircleStatistic,
            LinearStatistic,
            PlainTable,
            PlainTableOrder
        },
        data() {
            return {
                state :this.$route.params.state,
                color: Material,
                q5:'',
                q15_a:'0',
                q19:'',
                qf:'0',
                q7:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q8:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q9:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q10:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q11:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q12:{
                    nbr0:'0',
                    nbr1:'0',
                    nbr2:'0',
                    nbr_moins5:'0',
                    nbr_plus5:'0'
                },
                q21:{
                    tele:'0',
                    fre:'0',
                    pc:'0',
                    four:'0',
                    machine:'0'
                },
                q13:'',
                q16:0,
                q17:0,
                tt:0,
qf:'0',
                q22:0,
                q23:0,
                q24:0,
                q25:0,
                data5:[],   data6:[], datam:[], datac:[], datav:[], datad:[],
            }
        },
        watch: {
            $route: function(newVal, oldVal) {
                this.fetchData()
            }
        },

        computed: {
            activity() {
                return API.getActivity();
            },
            posts() {
                return API.getPost(3);
            },
            siteTrafficData() {
                return API.getMonthVisit;
            },
        },
        created(){



        },
        mounted(){
            this.fetchData()

        },
        methods: {
            caption2 (val) {
                return val *1;
            },
            fetchData() {
                var labelOption1 = {

                    normal: {
                        position:"inside",
                        fontSize: 13,
                        fontWeight:"bold",
                    }
                };
                var labelOption2 = {

                    normal: {
                        fontSize: 13,
                        fontWeight:"bold",
                    }
                };
                console.log("aaaaaaaaaa");
                const ECharts = window.echarts || undefined;
                if (ECharts === undefined) {
                    console.error('ECharts is not defined');
                }

                var myChart12 = ECharts.init(this.$refs.q1_2, 'material');

                var myChart = ECharts.init(this.$refs.main, 'material');
                var myChart2 = ECharts.init(this.$refs.q6, 'material');
                var myChart3 = ECharts.init(this.$refs.q14, 'material');
                var myChart9 = ECharts.init(this.$refs.q1_c, 'material');

                var myChart4 = ECharts.init(this.$refs.q15, 'material');
                var myChart5 = ECharts.init(this.$refs.q18, 'material');
                var myChart6 = ECharts.init(this.$refs.q19, 'material');
                var myChart7 = ECharts.init(this.$refs.q20, 'material');
                myChart12.showLoading();

                myChart.showLoading();
                myChart2.showLoading();
                myChart3.showLoading();
                myChart4.showLoading();
                myChart5.showLoading();
                myChart6.showLoading();
                myChart7.showLoading();
                myChart9.showLoading();

                console.log(this.$route.params.state)
                var formData = new FormData();
                if((this.$route.params.state)==='Toutes les villes'){
                    formData.append('pays','');
                }
                if((this.$route.params.state)==='Sfax'){
                    formData.append('pays','صفاقس');
                }
                if((this.$route.params.state)==='Gabès'){
                    formData.append('pays','قابس');
                }
                if((this.$route.params.state)==='Médenine'){
                    formData.append('pays','مدنين');
                }
                console.log(formData.pays)
                this.$http.post('https://acg-generations.com/acg_laravel/public/question5',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                    var data = response.bodyText
                    var obj = JSON.parse(data);

                    this.q5=obj.q5;
                    this.q6=obj.q6;
                    this.q7=obj.q7;
                    this.q8=obj.q8;
                    this.q9=obj.q9;
                    this.q10=obj.q10;
                    this.q11=obj.q11;
                    this.q12=obj.q12;

                    this.q13=obj.q13;
                    this.q14=obj.q14;
                    this.q15=obj.q15;
                    this.tt=obj.q15.total;

                    this.q15_a=obj.q15_a;
                    this.q16=obj.q16;
                    this.q17=obj.q17;
                    this.q18=obj.q18;
                    this.q19=obj.q19;
                    this.q20=obj.q20;
                    this.q21=obj.q21;
                    this.q22=obj.q22;
                    this.q23=obj.q23;
                    this.q24=obj.q24;
                    this.q25=obj.q25;
                    this.q1_c=obj.q1_c;

                    for(var i=0;i<this.q1_c.length;i++){
                        this.data5[i]=this.q1_c[i].q1_c
                        this.data6[i]=this.q1_c[i].total
                    }
                    this.qm=obj.qm;
                    this.qf=obj.qf;
                    this.datam[0]=this.qm.a
                    this.datam[1]=this.qm.b
                    this.datam[2]=this.qm.c
                    this.datam[3]=this.qm.d
                    this.qc=obj.qc;
                    this.datac[0]=this.qc.a
                    this.datac[1]=this.qc.b
                    this.datac[2]=this.qc.c
                    this.datac[3]=this.qc.d
                    this.qv=obj.qv;
                    this.datav[0]=this.qv.a
                    this.datav[1]=this.qv.b
                    this.datav[2]=this.qv.c
                    this.datav[3]=this.qv.d
                    this.qd=obj.qd;
                    this.datad[0]=this.qd.a
                    this.datad[1]=this.qd.b
                    this.datad[2]=this.qd.c
                    this.datad[3]=this.qd.d


                    myChart.hideLoading();
                    myChart2.hideLoading();
                    myChart3.hideLoading();
                    myChart4.hideLoading();
                    myChart5.hideLoading();
                    myChart6.hideLoading();
                    myChart7.hideLoading();
                    myChart9.hideLoading();
                    myChart12.hideLoading();

                    var arrayq5=[
                        {value:this.q5.a, label: labelOption2,  name:'Veuve'},
                        {value:this.q5.b, label: labelOption2,  name:'Célibataire'},
                        {value:this.q5.d, label: labelOption2,  name:'Divorcée'},
                        {value:this.q5.c, label: labelOption2, name:'Mariée'},
                    ]
                    var count=this.q5.count;

                    myChart.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return Math.round(arrayq5[id].value * 0.01 *count)+' '  ;
                            }},
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Veuve','Célibataire','Mariée','Divorcée'],
                            bottom: '0',
                            labels: {
                                fontSize:13
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq5
                        }]
                    });
                    /**********************************************/
                    var arrayq6=[
                        {value:this.q6.a, label: labelOption2, name:'Primaire'},
                        {value:this.q6.d, label: labelOption2,name:'Universitaire'},
                        {value:this.q6.b, label: labelOption2, name:'Illettré'},
                        {value:this.q6.c, label: labelOption2,name:'Secondaire'},
                    ]
                    var count=this.q6.count;

                    myChart2.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {  show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return Math.round(arrayq6[id].value * 0.01 *count)+' '  ;
                            }
                            },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Primaire','Illettré','Secondaire','Universitaire'],
                            bottom: '0',
                            labels: {
                                fontSize:13
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq6
                        }]
                    });
                    /***********************************************/
                    var arrayq14=[
                        {value:this.q14.b,label: labelOption2, name:'Garderie'},
                        {value:this.q14.a, label: labelOption2,name:'Grands-parents'},
                        {value:this.q14.c,label: labelOption2,name:'Autres'},

                    ]
                    var count=this.q14.count;

                    myChart3.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return  Math.round(arrayq14[id].value * 0.01 *count)+' '  ;
                            }
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Grands-parents','Garderie','Autres'],
                            bottom: '0',
                            labels: {
                                fontSize: 13
                            }
                            },


                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq14
                        }]
                    });
                    var labelOption = {
                        normal: {
                            show: true,
                            position:"inside",
                            align: "center",
                            verticalAlign: "middle",
                            rotate: 90,
                            formatter: '{c}%',
                            fontSize: 13,
                            rich: {
                                name: {
                                    textBorderColor: '#fff'
                                }
                            }
                        }
                    };
                    var labelOption16 = {
                        normal: {
                            show: true,
                            position:"insideBottom",
                            align: "left",
                            verticalAlign: "middle",
                            rotate: 90,
                            formatter: '{c}%',
                            fontSize: 16,
                            fontWeight:"bold"
                        }
                    };
                    /*********************************************/
                    myChart4.setOption({
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        radius:'50%',
                        label: {
                            normal: {
                                formatter: '{d}%  ',
                                backgroundColor: '#eee',
                                borderColor: '#aaa',
                                borderWidth: 1,
                                borderRadius: 4,

                                rich: {
                                    a: {
                                        color: '#999',
                                        lineHeight: 22,
                                        align: 'center'
                                    },
                                    b: {
                                        fontSize: 16,
                                        lineHeight: 33
                                    },

                                }
                            }
                        },
                        legend: {
                            bottom: '0',
                            data:['pension de veuves','pension d’orphelins','revenu agricole','pension de pauvreté'],
                            label:{fontSize:13,},},
                        toolbox: {show: true, orient: 'vertical', left: 'right', top: 'center',},
                        xAxis: [
                            {axisTick: {show: true, alignWithLabel: true, label:true}, data: [],}],
                        yAxis: [
                            {
                                type: 'value'
                            }
                        ],
                        series: [

                            { data:[this.q15.a], type: 'bar',label: labelOption,name:'pension de veuves'},
                            { data:[this.q15.b],  type: 'bar',label: labelOption,name:'pension d’orphelins'},
                            { data:[this.q15.c], type: 'bar',label: labelOption,name:'revenu agricole'},
                            { data:[this.q15.d], type: 'bar',label: labelOption,name:'pension de pauvreté'},
                        ]
                    });
                    /*********************************************/
                    var arrayq18=[
                        {value:this.q18.a,label: labelOption2, name:'Rurale'},
                        {value:this.q18.b,label: labelOption2, name:'Populaire'},
                        {value:this.q18.c,label: labelOption2,name:'Villa'},

                    ]
                    var count=this.q18.count;

                    myChart5.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return  Math.round(arrayq18[id].value * 0.01 *count)+' '  ;
                            }},
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Rurale','Populaire','Villa' ],
                            bottom: '0',
                            labels: {
                                fontSize: 13
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq18
                        }]
                    });
                    /*********************************************/
                    var arrayq19=  [{value:this.q19.d,label: labelOption2,name:'Propriétaire'},
                        {value:this.q19.c,label: labelOption2,name:'Location'},
                        {value:this.q19.a, label: labelOption2,name:'Maison collective'},
                        {value:this.q19.b, label: labelOption2,name:'Don'},
                    ]
                    var count= this.q19.count;

                    myChart6.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {  show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return   Math.round(arrayq19[id].value * 0.01 *count)+' '  ;
                            }},
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Maison collective','Don','Location','Propriétaire' ],

                            bottom: '0',
                            labels: {
                                fontSize:13
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq19
                        }]
                    });
                    /*********************************************/
                    var    arrayq20=[
                        {value:this.q20.a, label: labelOption2,name:'Excellent'},
                        {value:this.q20.b, label: labelOption2,name:'Médiocre'},
                        {value:this.q20.c,label: labelOption2,name:'Moyen'},
                        ]
                    var count=this.q20.count

                    myChart7.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {   show: true,
                            formatter: function (params) {
                                var id = params.dataIndex;
                                return Math.round(arrayq20[id].value * 0.01 *count)+' '  ;
                            }

                            },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Excellent','Médiocre','Moyen'],
                            bottom: '0',
                            labels: {
                                fontSize: 13
                            }

                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius:'70%',
                            label: {
                                normal: {
                                    formatter: '{d}%  ',
                                    position: 'inner'
                                }
                            },
                            data:arrayq20


                        }]
                    });
                    myChart9.setOption({
                        tooltip: {
                            trigger: 'axis',
                            axisPointer:{
                                show: true,
                                type : 'cross',
                                lineStyle: {
                                    width : 1
                                }
                            }
                        },
                        xAxis: {
                            name:'Les différents âges',
                            type: 'category',
                            data: this.data5,
                            axisTick: {
                                alignWithLabel: true
                            }

                        },
                        yAxis: {
                            name:'Le nombre',
                            type: 'value'
                        },
                        series: [{
                            name:'Nombres',
                            data: this.data6,
                            type: 'bar'
                        }]
                    });
                    /*********************************************/
                    myChart12.setOption({
                        color: [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            },
                            show: 'true'
                        },
                        legend: {data:['Mariée','Divorcée','Veuve','Célibataire'],},
                        grid: {
                            left: '13%',

                        },
                        xAxis: {type: 'value'},
                        yAxis: { type: 'category',
                            data: ['Illettré', 'Primaire', 'Secondaire', 'Universitaire']                        },

                        series: [
                            {
                                name: 'Mariée',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',

                                    normal: {
                                        show: true,
                                        position: 'inside',
                                    }
                                },
                                data: this.datam,
                            },
                            {
                                name: 'Veuve',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',
                                    normal: {
                                        show: true,
                                        position: 'inside'
                                    }
                                },
                                data: this.datav,
                            },
                            {

                                name: 'Célibataire',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',
                                    normal: {
                                        show: true,
                                        position: 'inside'
                                    }
                                },
                                data: this.datac,
                            },
                            {
                                name: 'Divorcée',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    color: '#fff',
                                    normal: {
                                        show: true,
                                        position: 'inside'
                                    }
                                },
                                data: this.datad,
                            },


                        ]
                    });
                    console.clear();

                    /*********************************************/
                }, response => {
                    // error callback
                });
            },


        }
    }
</script>

<style scoped>

    .legend {
        width: 100%;
        position: absolute;
        top: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/table1FR.vue